import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { TfiAngleRight, TfiAngleLeft } from "react-icons/tfi";

const Button = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 56px;
  background: ${({ theme }) => theme.slideBtn.backgroundColor};
  border: 0;
  outline: 0;
  padding: 0;
  z-index: 1;
  cursor: pointer;

  span {
    color: ${({ theme }) => theme.slideBtn.color};
    display: block;
    margin: 0 auto;
    font-size: 40px;

    svg {
      height: 26.4px;
      stroke-width: 1px;
      font-weight: 400;
    }
  }

  ${({ type }) =>
    type === "prev"
      ? css`
          left: 0px;
        `
      : css`
          right: 0px;
        `}

  ${({ theme }) =>
    theme.widgetWidth < 1220 &&
    css`
      span {
        font-size: 35px;
      }
    `}

  ${({ theme }) =>
    theme.widgetWidth < 800 &&
    css`
      width: 35px;
      top: 0;
      bottom: 0;
      span {
        font-size: 30px;
      }
    `}
`;

const SlideButton = ({ className, onClick, type }) => {
  const icons = {
    next: <TfiAngleRight />,
    prev: <TfiAngleLeft />,
  };

  return (
    <Button
      data-test="slide-button"
      type={type}
      className={className}
      onClick={onClick}
    >
      <span>{icons[type]}</span>
    </Button>
  );
};

SlideButton.propTypes = {
  type: PropTypes.oneOf(["prev", "next"]).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SlideButton;
